// removed by extract-text-webpack-plugin
module.exports = {"appBar":"theme__appBar___4dD4S","leftIcon":"theme__leftIcon___1Y1OM","chip":"theme__chip___3Gjj_","avatar":"theme__avatar___1IEZZ","deletable":"theme__deletable___3k2SH","delete":"theme__delete___2LAZw","deleteIcon":"theme__deleteIcon___3XWBI","deleteX":"theme__deleteX___2hNz-"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/chip/theme.scss
// module id = 352
// module chunks = 0